import {Affiliate, EarningsInfo, System} from '../types';
import {getDateDiff, dateFormatUTC, TimeInSeconds} from './DateUtils';

export const getAgreementSystem = (affiliate: Affiliate): System => {
    const {agreementInfo} = affiliate || {};
    const {system} = agreementInfo || {};
    return system || ({} as System);
};

export const getAccountClosedDate = (affiliate: Affiliate) => {
    if (!affiliate || !affiliate.agreementInfo) return null;
    const {decisionDetails} = affiliate.agreementInfo.currentVersion || {};
    return decisionDetails && dateFormatUTC(decisionDetails.date);
};

export const extractCurrentEarningsDeadlineInDays = (earningsInfo: EarningsInfo): number => {
    const {earningsDeadline} = earningsInfo || {};
    const remainingDays = getDateDiff(Date.now(), earningsDeadline, TimeInSeconds.DAY);
    return !remainingDays || remainingDays < 0 ? 0 : remainingDays;
};
